






































import {Component, Prop, Watch, Provide, Vue} from 'vue-property-decorator'
import {$, Helper} from 'simpli-web-sdk'
import {AuditoriaTransfolha} from '@/model/resource/AuditoriaTransfolha'
import {InputAuditoriaTransfolhaSchema} from '@/schema/resource/AuditoriaTransfolha/InputAuditoriaTransfolhaSchema'

@Component
export default class PersistAuditoriaTransfolhaView extends Vue {
  @Prop() id?: string

  @Provide('validator') validator = this.$validator

  schema = new InputAuditoriaTransfolhaSchema()
  auditoriaTransfolha = new AuditoriaTransfolha()

  async created() {
    await this.populate()
  }

  async populate() {
    const id = Number(this.id) || null

    if (id) {
      await this.auditoriaTransfolha.getAuditoriaTransfolha(id)
    }

    $.await.done('getAuditoriaTransfolha')
  }

  async persist() {
    const isValid = await this.validator.validateAll()

    if (!isValid) {
      Helper.abort('system.error.validation')
    }

    await this.auditoriaTransfolha.persistAuditoriaTransfolha()
    await Helper.successAndPush(
      'system.success.persist',
      '/auditoria-transfolha/list'
    )
  }
}
